var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.user.role === 'ADMIN')?_c('NavbarComponent',{attrs:{"routedata":_vm.adminNavBarRoutes.routes}}):_vm._e(),(_vm.user.role === 'USER')?_c('NavbarComponent',{attrs:{"routedata":_vm.assigneeNavBarRoutes.routes}}):_vm._e(),_c('div',{staticClass:"entity-section"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }